import React from 'react';
import { Dropdown } from '../Dropdown';
import { AAMVACaption } from './AAMVACaption';
import { AAMVACompletedResult } from './AAMVACompletedResult';
export const AAMVADropdowns = ({ aamvaJobResult, country, jobSid, jobStatus }) => {
    if (!aamvaJobResult) {
        return (React.createElement(Dropdown, { title: "DLV" },
            React.createElement(AAMVACaption, { dataUnavailable: true })));
    }
    return (React.createElement(AAMVACompletedResult, { aamvaJobResult: aamvaJobResult, country: country, jobSid: jobSid, jobStatus: jobStatus }));
};
